import React from 'react';
import Carousel from 'react-multi-carousel';
import 'react-multi-carousel/lib/styles.css';
import './style.css';

const CarrosselNoticias = ({ lnoticias }) => {
  // Extrai as notícias do formato news_results
  const noticias = lnoticias?.news_results || [];

  const responsive = {
    superLargeDesktop: {
      // screens larger than 1920px
      breakpoint: { max: 4000, min: 1920 },
      items: 4
    },
    desktop: {
      // screens larger than 1024px
      breakpoint: { max: 1920, min: 1024 },
      items: 4
    },
    tablet: {
      // screens larger than 464px
      breakpoint: { max: 1024, min: 768 },
      items: 3
    },
    mobile: {
      // screens smaller than 464px
      breakpoint: { max: 768, min: 0 },
      items: 1
    }
  };

  return <>
    <div className='mt-4'>
      <h2 className='section-title mb-3 px-2'>Notícias e Atualidades</h2>
      <div className='modern-carousel'>
        <Carousel 
          responsive={responsive} 
          infinite={true}
          autoPlay={true}
          autoPlaySpeed={6000}
          arrows={true}
          showDots={false}
        >
          {noticias && noticias.map((noticia, index) => {
            const thumbnailValido = noticia.thumbnail && noticia.thumbnail !== '' && !noticia.thumbnail.endsWith('/');
            return (
            <div key={`noticia${index}`} className='p-2'>
              <div className="card h-100 border-0 shadow-sm" style={{ borderRadius: '12px', overflow: 'hidden' }}>
                {thumbnailValido && (
                  <img 
                    src={noticia.thumbnail} 
                    className="card-img-top" 
                    alt={noticia.title}
                    style={{ width: '100%', height: '150px', objectFit: 'cover' }}
                  />
                )}
                <div className="card-body d-flex flex-column">
                  <h5 className="card-title" style={{ fontSize: '14px', lineHeight: '1.4', fontWeight: '600' }}>
                    {noticia.title}
                  </h5>
                  <div className="mt-auto">
                    <div className="d-flex justify-content-between align-items-center mb-2">
                      <small className="text-muted" style={{ fontSize: '12px' }}>
                        <i className="fas fa-newspaper me-1"></i> {noticia.source?.name || 'Fonte'}
                      </small>
                      <small className="text-muted" style={{ fontSize: '12px' }}>
                        <i className="fas fa-calendar-alt me-1"></i> {noticia.date}
                      </small>
                    </div>
                    <a 
                      href={noticia.link} 
                      target="_blank" 
                      rel="noopener noreferrer" 
                      className="btn btn-outline-primary btn-sm w-100 rounded-pill"
                    >
                      Ler mais
                    </a>
                  </div>
                </div>
              </div>
            </div>
            );
          })}
        </Carousel>
      </div>
    </div>
  </>
};

export default CarrosselNoticias;
